export default{
  login:{
    loginTypeTab:{
      loginway:"Account Login",
      loginway1:"Quick Login",
    },
    Placeholder:{
      username:"Enter username",
      password:"Enter password",
      mobile:"Enter registered phone or email",
      valCode:"Enter verification code"
    },
    Button:{
      loginSubBtn:'Login',
      getCode:{
        codeBtnText:"Get Code",
        reSendcodeBtnText:"Resend Code",
        countdown:"seconds to resend"
      }
    },
    Checkbox:{
      isRemember:'Remember me',
    },
    loginOtherOpts:{
      haveNoAccuont:"No account?",
      href:"Quick Register"
    },
    rules:{
      required:{
        username:"Username required",
        password:"Password required",
        mobile:"Phone number required",
        valCode:"Verification code required"
      }
    },
    Message:{
      mobile:'Enter phone number',
      sendSuccess:"Verification code sent!",
    },
    Alert:{
        error:{
            title:'Notification',
            text:'Request failed, please try again',
            buttonText:'OK',
        }
    },
  }
}